
const APIURL = window.location.origin 
//const APIURL = 'https://int.servizioeserciziamericanexpress.it';
//const APIURL = 'https://stg.servizioeserciziamericanexpress.it';
//const APIURL = 'https://www.servizioeserciziamericanexpress.it';


function getLoginUrl() {
	let servletURL = APIURL + '/oam/server/authentication?type=amex';
	return servletURL;
}

function getSuccessUrl() {
	let servletURL = APIURL + '/oauth2/rest/authz?response_type=code&client_id=AmexClient&domain=AmexIdentityDomain&scope=AmexApplication.microservices&state=xyz&redirect_uri=' + APIURL + '/login';
	return servletURL;
}

function getServletAccountUrl() {
	let servletURL = '/api/services/serviziamex-account-manager/';
	return servletURL;
}

function getServletTransactionUrl() {
	let servletURL = '/api/services/serviziamex-transaction-manager/';
	return servletURL;
}

function getServletStatisticsUrl() {
	let servletURL = '/api/services/serviziamex-statistics/';
	return servletURL;
}

function getServletDisputesUrl() {
	let servletURL = '/api/services/serviziamex-disputes/';
	return servletURL;
}

function getServletBalanceUrl() {
	let servletURL = '/api/services/serviziamex-account-balance/';
	return servletURL;
}

function getServletOutstandingsUrl() {
	let servletURL = '/api/services/serviziamex-outstandings/';
	return servletURL;
}

function getServletEboxUrl() {
	let servletURL = '/api/services/serviziamex-ebox/';
	return servletURL;
}


var Urls = {

	//login
	LOGIN: getLoginUrl(),
	SUCCESS_URL: getSuccessUrl(),
	OAUTH: "/api/oauth/v2/token",


	// ACCOUNT
	WELCOME: getServletAccountUrl() + "welcome",

	// Modifica Telefono Login
	OTP_TEL_LOGIN: getServletAccountUrl() + "verifyOTPChangeCellNumber",
	SET_TEL_LOGIN: getServletAccountUrl() + 'setCellNumberLogin',

	//modifica Telefono(setting)
	SEND_OTP_OLD_TEL: getServletAccountUrl() + "validateOldCellNumber",
	VALIDATE_OTP_OLD_TEL: getServletAccountUrl() + "verifyOTP-ValidateOldCellNumber",
	SEND_OTP_AND_NEW_TEL: getServletAccountUrl() + "changeNumber",
	VALIDATE_NEW_TEL: getServletAccountUrl() + "verifyOTPChangeCellNumber",

	// Modifica Password
	SEND_OTP_PASSWORD: getServletAccountUrl() + "setNewPassword",
	OTP_PASSWORD: getServletAccountUrl() + "verifyOTP-setNewPassword",

	//Modifica Email
	UPDATE_MAIL: getServletAccountUrl() + "updateEmail",

	//Registrazione
	REGISTER_MERCHANT: getServletAccountUrl() + "register/merchant",
	REGISTER_POS: getServletAccountUrl() + "register/pos",
	VALIDATE_USER: getServletAccountUrl() + "register/validateMerchantUser",
	VALIDATE_POS: getServletAccountUrl() + "register/validatePosUser",
	VERIFY_OTP_USER: getServletAccountUrl() + "register/verifyOTP-MerchantRegister",
	VERIFY_OTP_POS: getServletAccountUrl() + "register/verifyOTP-posRegister",

	//BALANCE
	SEARCH_ACCOUNT_BALANCE: getServletBalanceUrl() + "searchAccountBalance",
	GET_PDF_ACCOUNT_BALANCE: getServletBalanceUrl() + "getPDFAccountBalance",

	// TRANSACTION
	SEARCH_POINT_OF_SALES: getServletTransactionUrl() + "searchPointOfSales",
	GET_TOTAL_TRANSACTION: getServletTransactionUrl() + "getTotalTransaction",
	GET_SUMMARY_LIST: getServletTransactionUrl() + "getSummaryList",
	GET_SUMMARY_TRANSACTION_LIST: getServletTransactionUrl() + "getSummaryTransactionList",
	GET_TOTAL_SUMMARY: getServletTransactionUrl() + "getTotalSummary",
	GET_STATISTICS: getServletStatisticsUrl() + "getStatistics",
	GET_TRANSACTION_LIST: getServletTransactionUrl() + "getTransactionList",

	// OUTSTANDING
	GET_OUTSTANDING: getServletOutstandingsUrl() + "getOutstandings",

	// EBOX
	DETAIL_REPORT: getServletEboxUrl() + "getReport",
	EBOX_REQUEST: getServletEboxUrl() + "eboxRequest",
	ENROLL_EBOX: getServletEboxUrl() + "enroll",
	MODIFY_EBOX: getServletEboxUrl() + "modify",
	MODIFY_EMAIL_EBOX: getServletEboxUrl() + "modifyEmail",
	GET_EBOX_LIST: getServletEboxUrl() + "getEboxList",
	GET_EBOX_PROFILE: getServletEboxUrl() + "getEboxProfile",
	SEARCH_USER_LIST: getServletEboxUrl() + "searchUserList",
	SEARCH_USER_LIST_BY_SOC: getServletEboxUrl() + 'searchUserListBySoc',
	SEARCH_POS_LIST: getServletEboxUrl() + 'searchPosList',
	SEARCH_USER_POS_LIST: getServletEboxUrl() + 'searchUserByPos',
	SEARCH_PRATICES: getServletEboxUrl() + "searchPratices",
	EBOX_DETAIL: getServletEboxUrl() + "detail",
	EBOX_DOWNLOAD_ALLEGATO: getServletEboxUrl() + "downloadAttach",
	EBOX_UPLOAD_ALLEGATO: getServletEboxUrl() + "uploadFile",
	GET_POINT_OF_SALES: getServletEboxUrl() + 'getPointOfSales',
	ADD_MULTIPLE_ADMIN: getServletEboxUrl() + "addMultipleAdmin",
	DISPUTE: getServletDisputesUrl() + "getDisputes",

	// SESSION_EXPIRED
	SESSION: getServletAccountUrl() + "getSession",
	
}

var ApiConfig = {
	'url': Urls,
}


export {
	ApiConfig, APIURL
};